import { ApiStatus } from "../types/api/status"
import { useDispatch, useSelector } from "../redux/store"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"
import { readLocalStorage } from "../toolbox/helpers/local-storage-helpers"
import { LocalStorageKey } from "../types"
import { changeStatus, onSetSelectedProductUse, selectProductUseState, setAction, onFetchProductUse } from "../redux/slices/ProductUsageAttributeSlice"
import { ProductUsageAttributeAPI } from "../apis/ProductUsageAttributeAPI"
import { ProductUse } from "../types/slices/productUsageAttributeType"

export const useProductUsageAttributeStore = () => {

    const dispatch = useDispatch()
    const { productUsageAttributes, productUseSelected, status, action } = useSelector(selectProductUseState)

    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const idcompany = userData?.idcompany

    const getProductUsageAttribute = async (search='') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductUsageAttributeAPI.getProductUsageAttribute({search:search})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const getProductUsageAttributeByCompany = async (search='') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductUsageAttributeAPI.getProductUsageAttributeByCompany({search:search, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            dispatch(onFetchProductUse(detail))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const createProductUsageAttribute = async (data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductUsageAttributeAPI.createProductUsageAttribute({...data, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const createProductWithUsageAttribute = async (iduse:number, data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductUsageAttributeAPI.createProductWithUsageAttribute(iduse, data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const editProductUsageAttribute = async (iduse: number, data: any) => {
        try {
        dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductUsageAttributeAPI.editProductUsageAttribute(iduse, {...data, idcompany: idcompany})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const deleteProductUsageAttribute = async (iduse: number) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await ProductUsageAttributeAPI.deleteProductUsageAttribute(iduse)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const setSelectedStore = (productUse: ProductUse) => {
        try {
            dispatch(onSetSelectedProductUse(productUse))
        } catch (error) {
            console.log(error)
        }
    }

    const setActionProductUse = (state) => {
        try {
            dispatch(setAction(state))
        } catch (error) {
            console.log(error)
        }
    }

    return {
        //states
        productUsageAttributes,
        productUseSelected,
        status,
        action,
        //actions
        getProductUsageAttribute,
        getProductUsageAttributeByCompany,
        createProductUsageAttribute,
        createProductWithUsageAttribute,
        editProductUsageAttribute,
        deleteProductUsageAttribute,
        setSelectedStore,
        setActionProductUse,
    }
}